import { render, staticRenderFns } from "./TherapyPhoneNo.vue?vue&type=template&id=a9bd40bc"
import script from "./TherapyPhoneNo.vue?vue&type=script&lang=js"
export * from "./TherapyPhoneNo.vue?vue&type=script&lang=js"
import style0 from "./TherapyPhoneNo.vue?vue&type=style&index=0&id=a9bd40bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports